var react = {exports: {}};export{react as __module};//# sourceMappingURL=index.js.map
